"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _isInstanceOf = _interopRequireDefault(require("transmute/isInstanceOf"));

var _isObject = _interopRequireDefault(require("transmute/isObject"));

var PaginatedSearchResult = (0, _immutable.Record)({
  query: null,
  results: (0, _immutable.List)(),
  hasMore: false,
  offset: 0,
  total: 0
}, 'PaginatedSearchResult');

PaginatedSearchResult.fromJS = function (json) {
  if (!(0, _isObject.default)(json)) {
    return json;
  }

  return PaginatedSearchResult((0, _extends2.default)({}, json, {
    results: (0, _immutable.fromJS)(json.results)
  }));
};

PaginatedSearchResult.isPaginatedSearchResult = (0, _isInstanceOf.default)(PaginatedSearchResult);
var _default = PaginatedSearchResult;
exports.default = _default;
module.exports = exports.default;